const stateRoot = (state) => state.history_plans;

export const getIsPlanExpanded = (state, planId) => stateRoot(state)[planId];
